import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'log-licenze',
    initialState: {
        log_licenze: [],
        statusAction: 'READY',
    },
    actions: ['GET_LOG_LICENZE'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.GET_LOG_LICENZE_SUCCESS:
                return {
                    ...state,
                    log_licenze: action.payload.log_licenze,
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        getLogLicenzeRequest: (codiceUtente) => ({
            type: types.GET_LOG_LICENZE_REQUEST,
            payload: { codiceUtente },
        }),
        getLogLicenzeSuccess: ({ log_licenze }) => ({
            type: types.GET_LOG_LICENZE_SUCCESS,
            payload: { log_licenze },
        }),
        getLogLicenzeFailed: error => ({ type: types.GET_LOG_LICENZE_FAILED, error: true, payload: { error } }),
    }),
});
